module.exports = __webpack_public_path__ + "static/assets/e9ae6dc958d4dcf32971dc199d130aac.gif";